<!-- Responsibility: Implement stat badge behavior for the ui/components surface.
Scope: Owns ui/components concerns only; cross-surface orchestration is excluded. -->
<stat-badge>
  <div
    class="stat"
    role="button"
    tabindex="0"
    aria-label={ `Open ${props.statKey} details` }
    onclick={ openDetails }
    onkeydown={ onKeydown }
  >
    <span class="label">{ props.statKey }:</span><span class="val">{ props.value }</span>
  </div>

  <script>
    import { dispatcher } from '../../app-states.js'
    import { buildInfoDialog } from '../dialog/dialog-openers.ts'
    import { TOPICS } from "@anyquest/shared-core"

    export default {
      openDetails() {
        dispatcher.trigger('stat-badge', TOPICS.ui.dialogOpen, buildInfoDialog({
          options: {
            title: this.props.statKey,
            desc: this.props.desc,
            meta: this.props.meta,
          },
        }))
      },

      onKeydown(e) {
        if (e.key !== 'Enter' && e.key !== ' ') return
        e.preventDefault()
        this.openDetails()
      },
    }
  </script>

  <style>
    :host { display: block; }
    .stat {
      background: var(--bg);
      border: 1px solid var(--border);
      padding: 0.625rem 0.875rem;
      display: flex;
      justify-content: space-between;
      align-items: baseline;
      border-radius: 0.25rem;
      transition: 0.2s;
      cursor: url('data:image/svg+xml;utf8,<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="gold" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><circle cx="11" cy="11" r="8"/><line x1="21" y1="21" x2="16.65" y2="16.65"/></svg>') 12 12, pointer;
    }
    .stat:hover  { background: var(--gold-glow); border-color: var(--gold); transform: scale(1.02); z-index: 2; position: relative; }
    .stat:active { background: var(--gold-glow); border-color: var(--gold); }
    .label { font-size: var(--space-sm); color: var(--text-muted); font-weight: bold; letter-spacing: 0.1em; }
    .val { font-size: 1.1rem; color: var(--text-prose); font-weight: bold; margin: 0; padding: 0; line-height: 1; }
  </style>
</stat-badge>
